import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'bs-load-more',
    template: require('./load.more.component.html')
})
export class LoadMoreComponent {

    @Input('total-count') total_count: number = 0;
    @Input('current-count') current_count: number = -1;
    @Input('button-title') button_title: string;
    @Input('button-class') button_class: string = 'btn btn-primary';
    @Input('button-wrapper-class') button_wrapper_class: string = 'text-center';
    @Input('button-disabled') button_disabled: boolean = false;

    @Output('on-load-more') onLoadMore: EventEmitter<any> = new EventEmitter<any>();

    loadMore() {
        this.onLoadMore.emit({});
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/load-more/load.more.component.ts